import React, { Suspense } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  House,
  Search,
  RadioTower,
  Users,
  Book,
  LucideIcon as LucideIconType,
} from "lucide-react";

// Define an interface for the props
interface MenuFieldProps {
  iconSrc: string;
  text?: string;
  link: string;
  name: string;
  isHovered: boolean;
}

const MenuFieldHero = styled(Link)<{ isHovered: boolean }>`
  display: flex;
  height: 41px;
  padding-left: 15px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 6px;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 17px;
`;

const Text = styled.span<{ isHovered: boolean }>`
  color: #3c3c3d;
  font-family: "Sharp Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  opacity: 1;
  transition: opacity 0.1s ease-in-out, width 0.1s ease-in-out;
  text-align: left;
  @media (max-width: 1450px) {
    width: ${({ isHovered }) => (isHovered ? "auto" : "0")};
    visibility: ${({ isHovered }) => (isHovered ? "visible" : "hidden")};
  }
`;

const IconContainer = styled.div<{ isHovered: boolean }>`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Map icon names to actual components
const iconMap: Record<string, LucideIconType> = {
  house: House,
  search: Search,
  "radio-tower": RadioTower,
  users: Users,
  book: Book,
};

const MenuField: React.FC<MenuFieldProps> = ({
  text,
  iconSrc,
  link,
  name,
  isHovered,
}) => {
  const IconComponent = iconMap[name];

  return (
    <MenuFieldHero to={link} isHovered={isHovered}>
      <Content>
        <IconContainer isHovered={isHovered}>
          {IconComponent ? (
            <IconComponent size={18} color="#3C3C3D" />
          ) : (
            <div
              style={{ width: 18, height: 18, backgroundColor: "#f0f0f0" }}
            />
          )}
        </IconContainer>
        <Text isHovered={isHovered}>{text}</Text>
      </Content>
    </MenuFieldHero>
  );
};

export default MenuField;
